import { type ReactElement } from "react";
import { useLanguage } from "@/context";

export const LangToggle = (): ReactElement => {
  const { lang, toggleLanguage } = useLanguage();

  return (
    <button
      className="lang-toggle"
      onClick={toggleLanguage}
      aria-label={lang === "en" ? "Cambiar a español" : "Switch to English"}
      type="button"
    >
      {lang === "en" ? "ES" : "EN"}
    </button>
  );
};
